// Once pubfig is live, queue.push runs the callback synchronously, so a failure inside the ad stack
// would surface as a React error and crash the page. Ad failures must never take the page down.
export function freestarQueue(fn: (freestar: FreestarGlobal) => void) {
  window.freestar = window.freestar ?? ({ queue: [] } as unknown as FreestarGlobal);
  window.freestar.queue.push(() => {
    try {
      if (window.freestar) fn(window.freestar);
    } catch (error) {
      console.warn("[freestar] queued call failed", error);
    }
  });
}
